<template>
    <div class="automation-block-editor run-javascript">
        <div class="editor-row customize-editor-minimize">
            <div class="editor-row-title">{{ $t('auto.runJavaScriptJavaScriptKodu') }}</div>
            <div class="code-editor-wrapper">
                <div class="code-editor-header">
                    <div class="tips">
                        <div class="tip">
                            <md-icon>info</md-icon>
                            <span>{{ $t('auto.runJavaScriptBuBlokKullanCNNYazdJavascriptKodunuAlTRR') }}</span>
                        </div>
                        <div class="tip">
                            <md-icon>warning</md-icon>
                            <span>{{ $t('auto.runJavaScriptGVenlikNedenlerindenDolayBazJavascriptZellikleriKSTlanmTR') }}</span>
                        </div>
                    </div>
                    <div class="actions d-flex gap-5">
                        <a-button type="primary" class="id-finder-btn" @click="openIDFinder" style="margin-right: 10px">
                            <i class="material-icons" style="font-size: 15px; margin-right: 5px">search</i>
                            {{ $t('auto.runJavaScriptIDFinder') }}
                        </a-button>
                        <a-button type="primary" class="fullscreen-btn" @click="toggleFullScreen" style="margin-right: 10px">
                            <i class="material-icons" style="font-size: 15px; margin-right: 5px">
                                {{ isFullScreen ? 'fullscreen_exit' : 'fullscreen' }}
                            </i>
                            {{ isFullScreen ? 'Çıkış' : 'Tam Ekran' }}
                        </a-button>
                        <a-button type="primary" class="ai-assistant-btn" @click="showPromptWizard">
                            <img src="/static/img/copilot.png" width="15" height="15" style="margin-right: 5px" />
                            {{ $t('auto.runJavaScriptSupsisAsistan') }}
                        </a-button>
                    </div>
                </div>

                <div class="code-editor">
                    <div class="available-libraries">
                        <span>{{ $t('auto.runJavaScriptKullanLabilirKTPhaneler') }}</span>
                        <code>moment</code>, <code>{{ $t('auto.runJavaScriptLodash') }}</code>, <code>{{ $t('auto.runJavaScriptAxiosSadeceGetVePost') }}</code>
                    </div>

                    <div class="available-variables">
                        <span>{{ $t('auto.runJavaScriptKullanLabilirDeIKenler') }}</span>
                        <code>params</code> {{ $t('auto.runJavaScriptNcekiBloklarNDeErleri') }}
                        <code>{{ $t('auto.runJavaScriptTaskReadattributeKeyDefaultvalue') }}</code>,
                        <code>{{ $t('auto.runJavaScriptTaskBindattributeData') }}</code>
                    </div>

                    <div class="attribute-help">
                        <span>{{ $t('auto.runJavaScriptOtomasyonDeIKenleri') }}</span>
                        <code>{{ $t('auto.runJavaScriptBlockBlockid') }}</code>, <code>{{ $t('auto.runJavaScriptEventEventtypeEventname') }}</code>, <code>{{ $t('auto.runJavaScriptSystemDate') }}</code>,
                        <code>{{ $t('auto.runJavaScriptWebhookBodyFieldname') }}</code> {{ $t('auto.runJavaScriptEklindeKullanLabilir') }}
                    </div>

                    <div id="monaco-editor-container" class="monaco-editor-container" :class="{ 'fullscreen-editor': isFullScreen }"></div>
                </div>

                <div class="code-restrictions">
                    <div class="restriction-title">{{ $t('auto.runJavaScriptKSTlamalar') }}</div>
                    <ul>
                        <li>{{ $t('auto.runJavaScriptProcessExitChildProcessGibiTehlikeliNodeJsZellikleriYasaktR') }}</li>
                        <li>{{ $t('auto.runJavaScriptRequireEvalVeFunctionFonksiyonlarKullanLamaz') }}</li>
                        <li>{{ $t('auto.runJavaScriptDosyaSistemiFsKriptoVeAILemleriKSTlanmTR') }}</li>
                        <li>{{ $t('auto.runJavaScriptKodAlMaSResi5SaniyeIleSNRlDR') }}</li>
                        <li>{{ $t('auto.runJavaScriptHTTPIstekleriIInZamanAM3Saniyedir') }}</li>
                        <li>{{ $t('auto.runJavaScriptSonsuzDNgLerVeServerlarOluTurulamaz') }}</li>
                    </ul>
                </div>

                <div class="example-usage">
                    <div class="example-title">{{ $t('auto.runJavaScriptKodRneI') }}</div>
                    <pre>
{{ $t('auto.runJavaScriptAsyncFunctionMainParamsMomentKTPhanesiniKullanmaRneIConstNowMomentFormatYyyyMmDdHhMmSsLodashKullanMConstUsersNameMesutAge30NameAhmetAge25ConstOldestMaxbyUsersAgeOtomasyonDeIKenleriniKullanmaConstDateTaskReadattributeSystemDateConstContactnameTaskReadattributeContactFullnameSupsisSdkKullanMRneILetResultTryKullanCLarListelemeConstUserlistAwaitSupsisUsersListResultUsercountUserlistLengthKiIBilgisiAlmaVarsaIfParamsContactidConstContactAwaitSupsisContactGetParamsContactidResultContactinfoNameContactFullnameEmailContactEmailModLlerZerindeAlMa1TMModLleriListeleConstModulesAwaitSupsisModuleListResultModulecountModulesLength2ZelBirModLIleAlMaRnekMTerilerModLConstNewcustomerAwaitSupsisModuleCustomersCreateFullnameContactnameRegisterdateNowStatusActiveResultNewcustomeridNewcustomerId3ModLKaydAramaConstCustomerrecordsAwaitSupsisModuleCustomersSearchFiltersFieldStatusOperatorEqValueActiveSortFullname1CursorPage1Perpage10ResultCustomercountCustomerrecordsTotal4ZelAktiviteOluTurmaConstCustomactivityAwaitSupsisActivityCreateMessageOtomasyonTarafNdanZelAktiviteOluTurulduNotificationUsersIdParamsUserid123456789ConfigWebFalseEmailTrueMobileFalseConfigWebTrueEmailTrueMobileFalseActionsActionViewRecordPayloadTitleMTeriDetayTableidCustomersRecordidParamsCustomerid123456ActionOpenWidgetPayloadTitleMTeriWidgetUrlHttpsExampleComCustomerDashboardFullscreenFalseModeUrlHtmlUsersUserid1ResultActivityidCustomactivityIdCatchErrorHataYNetimiResultErrorErrorMessageDNdRLenDeErBloUnKtSOlarakKaydedilirReturnCurrenttimeNowOldestuserOldestNameCalculatedParamsPreviousvalueParamsPreviousvalue20SystemdateDateContactnameContactnameApiresultsResult') }}
</pre
                    >
                </div>
            </div>
        </div>

        <!-- JavaScript Asistan Modal -->
        <a-modal
            v-model="showJsAssistant"
            :title="$t('auto.runJavaScriptJavaScriptAsistan')"
            :width="800"
            :footer="null"
            @cancel="handleAssistantClose"
        >
            <div class="js-assistant-modal">
                <div class="js-assistant-description">
                    <h4>{{ $t('auto.runJavaScriptJavaScriptKodunuYapayZekaIleOluTurun') }}</h4>
                    <p>
                        {{ $t('auto.runJavaScriptYapmakIstediInizILemiDoAlDildeAKlayNSupsisAsistanSizinIInJavascriptKodunuOluTursun') }}
                    </p>

                    <div class="js-capabilities">
                        <div class="capabilities-header">
                            <a-icon type="bulb" />
                            <h5>{{ $t('auto.runJavaScriptYapabilecekleriniz') }}</h5>
                        </div>
                        <div class="capabilities-content">
                            <div class="capability-item">
                                <i class="material-icons">functions</i>
                                <span>{{ $t('auto.runJavaScriptHesaplamalarYapma') }}</span>
                            </div>
                            <div class="capability-item">
                                <i class="material-icons">compare_arrows</i>
                                <span>{{ $t('auto.runJavaScriptVeriDNMleri') }}</span>
                            </div>
                            <div class="capability-item">
                                <i class="material-icons">filter_list</i>
                                <span>{{ $t('auto.runJavaScriptVeriFiltreleme') }}</span>
                            </div>
                            <div class="capability-item">
                                <i class="material-icons">http</i>
                                <span>{{ $t('auto.runJavaScriptAPIIstekleriYapma') }}</span>
                            </div>
                            <div class="capability-item">
                                <i class="material-icons">today</i>
                                <span>{{ $t('auto.runJavaScriptTarihILemleri') }}</span>
                            </div>
                            <div class="capability-item">
                                <i class="material-icons">format_list_numbered</i>
                                <span>{{ $t('auto.runJavaScriptDiziILemleri') }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="prompt-container">
                    <s2-textarea
                        v-model="jsPrompt"
                        :rows="4"
                        :placeholder="'Örnek: Bir müşterinin toplam harcamasını hesapla ve eğer 1000 TL üzerindeyse VIP olarak etiketle'"
                        ref="promptTextarea"
                    />

                    <div class="example-prompts">
                        <div
                            class="example-prompt"
                            @click="
                                selectExamplePrompt(
                                    'Bir müşterinin toplam harcamasını hesapla ve eğer 1000 TL üzerindeyse VIP olarak etiketle'
                                )
                            "
                        >
                            <a-icon type="calculator" />
                            <span>{{ $t('auto.runJavaScriptHarcamaHesaplaVeEtiketle') }}</span>
                        </div>
                        <div
                            class="example-prompt"
                            @click="
                                selectExamplePrompt(
                                    'Müşteri adını ve soyadını alarak tam ad oluştur ve selamlama mesajı hazırla'
                                )
                            "
                        >
                            <a-icon type="user" />
                            <span>{{ $t('auto.runJavaScriptMTeriBilgisiyleMesajHazRla') }}</span>
                        </div>
                        <div
                            class="example-prompt"
                            @click="
                                selectExamplePrompt(
                                    'API\'den hava durumu bilgisi al ve sıcaklığa göre aktivite önerisi yap'
                                )
                            "
                        >
                            <a-icon type="cloud" />
                            <span>{{ $t('auto.runJavaScriptAPIIleHavaDurumunaGReNeri') }}</span>
                        </div>
                    </div>

                    <div class="buttons-container">
                        <a-button @click="handleAssistantClose">{{ $t('auto.runJavaScriptPtal') }}</a-button>
                        <a-button type="primary" :loading="assistantLoading" @click="generateJavaScriptCode">
                            {{ $t('auto.runJavaScriptKodOluTur') }}
                        </a-button>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import _ from "lodash";
import * as monaco from "monaco-editor";
import AutomationAttributesGenerator from "../../../utils/AutomationAttributesGenerator";

import CoPilot from "../../../../../../utils/CoPilot";
import S2Textarea from "../../../../../../components/S2Textarea.vue";
import { createCompletionItemProvider } from "../createCompletionItemProvider";
import { useSupsisCompletion } from "../composables/useSupsisCompletion";
import { mapActions, mapState } from "vuex";

export default {
    name: "RunJavaScript",
    components: {
        S2Textarea,
    },
    props: ["value", "blockId", "automation"],
    setup() {
        // Supsis SDK otomatik tamamlama işlevini kur
        const { registerEditor } = useSupsisCompletion({
            // Gerekli konfigürasyon seçenekleri ile başlatılıyor
        });

        return {
            registerEditor,
        };
    },
    data() {
        return {
            payload: _.cloneDeep(this.value) || {
                code: "",
            },
            cancels: [],
            editor: null,
            attributesLoaded: false,
            autocompleteInitialized: false,
            automationAttributes: [],
            showJsAssistant: false,
            jsPrompt: "",
            assistantLoading: false,
            examplePrompts: [
                "Bir müşterinin toplam harcamasını hesapla ve eğer 1000 TL üzerindeyse VIP olarak etiketle",
                "Müşteri adını ve soyadını alarak tam ad oluştur ve selamlama mesajı hazırla",
                "API'den hava durumu bilgisi al ve sıcaklığa göre aktivite önerisi yap",
                "Geçmiş siparişlerin ortalamasını hesapla ve gelecek tahmini yap",
                "Müşteri adresinden il ve ilçe bilgisini ayıkla ve kargo firmasını belirle",
            ],
            moduleCache: [],
            hasUnsavedChanges: false,
            originalCode: "",
            isFullScreen: false,
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users?.data || [],
            me: (state) => state.auth.user.user?._id,
        }),
    },
    async created() {
        // Supsis store modüllerini sync et (otomatik tamamlama için)
        try {
            await this.$store.dispatch("module/syncModules");
        } catch (error) {
            console.error("Modülleri sync ederken hata oluştu:", error);
        }
        // Modülleri yükle (Monaco editor'de kullanılacak)
        try {
            if (this.$store && this.$store.state.module && this.$store.state.module.modules) {
                this.moduleCache = this.$store.state.module.modules;
            } else {
                const response = await this.$_api.table.getModuleList();
                if (response.data && response.data.data) {
                    this.moduleCache = response.data.data;
                }
            }
        } catch (error) {
            console.error("Modül listesi yüklenirken hata oluştu:", error);
        }
    },
    mounted() {
        // Orijinal kodu kaydet (unsaved changes kontrolü için)
        this.originalCode = this.payload.code || "";
        this.initMonaco();
        this.loadAutomationAttributes();
        window.addEventListener("resize", this.handleResize);
        window.addEventListener("keydown", this.handleKeyDown);
    },
    beforeDestroy() {
        this.destroyMonaco();
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener("keydown", this.handleKeyDown);
    },
    methods: {
        ...mapActions({
            addNewWindow: "app/addNewWindow",
        }),
        getFlatAttributes(attributes) {
            const flat = (attr, parentLabel = "") => {
                const label = parentLabel ? `${parentLabel} > ${attr.label}` : attr.label;
                attr.fullLabel = label;

                if (attr.subAttributes) {
                    return [attr, ...attr.subAttributes.flatMap((x) => flat(x, attr.fullLabel))];
                }
                return [attr];
            };
            return attributes.flatMap((x) => flat(x, undefined));
        },
        loadAutomationAttributes() {
            const automation = this.automation || this.$store.state.automation.current;
            if (automation) {
                let attributes = AutomationAttributesGenerator.create().list(automation);
                attributes = attributes.filter((x) => !["conversation", "contact"].includes(x.context));
                this.automationAttributes = attributes;
                this.flatAutomationAttributes = this.getFlatAttributes(attributes);
                this.attributesLoaded = true;

                // Editör mevcutsa önceki sağlayıcıları temizleyip yeni provider ekle
                if (this.editor) {
                    this.cancels.forEach((disposeFn) => disposeFn());
                    this.cancels = [];
                    const disposable = monaco.languages.registerCompletionItemProvider(
                        "javascript",
                        createCompletionItemProvider(this.automationAttributes, this.moduleCache)
                    );
                    this.cancels.push(() => disposable.dispose());
                }

                console.log("Yüklenen attribute sayısı:", attributes.length);
                if (attributes.length > 0) {
                    console.log("Örnek attribute:", attributes[0]);
                }
            }
        },
        initMonaco() {
            // Monaco'da browser global type'larını ve önerilerini kaldır
            monaco.languages.typescript.javascriptDefaults.setExtraLibs([]);
            monaco.languages.typescript.javascriptDefaults.setCompilerOptions({
                target: monaco.languages.typescript.ScriptTarget.ES6,
                module: monaco.languages.typescript.ModuleKind.CommonJS,
                allowNonTsExtensions: true,
                noLib: true, // Varsayılan kütüphaneleri (örn: lib.dom.d.ts) yükleme
            });
            // monaco-editor başlat
            this.editor = monaco.editor.create(document.getElementById("monaco-editor-container"), {
                value: this.payload.code,
                language: "javascript",
                theme: "vs-dark",
                minimap: {
                    enabled: false,
                },
                automaticLayout: true,
                scrollBeyondLastLine: true,
                lineNumbers: "on",
                roundedSelection: true,
                cursorStyle: "line",
                wordWrap: "on",
                tabSize: 2,
                fontSize: 14,
                suggestOnTriggerCharacters: true,
                quickSuggestions: {
                    other: true,
                    comments: false,
                    strings: true,
                },
                acceptSuggestionOnCommitCharacter: true,
                acceptSuggestionOnEnter: "on",
                inlineSuggest: {
                    enabled: true,
                },
                // Scroll konfigürasyonu
                scrollbar: {
                    vertical: 'visible',
                    horizontal: 'visible',
                    useShadows: false,
                    verticalHasArrows: false,
                    horizontalHasArrows: false,
                    verticalScrollbarSize: 10,
                    horizontalScrollbarSize: 10
                },
                overviewRulerLanes: 0,
                hideCursorInOverviewRuler: true,
                overviewRulerBorder: false,
            });

            // Düzenlemeleri payload'a ilet
            this.editor.onDidChangeModelContent(() => {
                this.payload.code = this.editor.getValue();
                this.hasUnsavedChanges = this.payload.code !== this.originalCode;
                this.$emit("input", this.payload);
            });

            // Trigger karaketerlerini ayarla
            this.editor.getModel().updateOptions({
                tabSize: 2,
                insertSpaces: true,
                trimAutoWhitespace: true,
                semanticHighlighting: {
                    enabled: true,
                },
            });

            // Otomatik öneriler için trigger karakterleri ekle
            monaco.languages.setLanguageConfiguration("javascript", {
                wordPattern: /(-?\d*\.\d\w*)|([^\`\~\!\@\#\$\%\^\&\*\(\)\=\+\[\{\]\}\\\|\;\:\'\"\,\.\<\>\/\?\s]+)/g,
                comments: {
                    lineComment: "//",
                    blockComment: ["/*", "*/"],
                },
                brackets: [
                    ["{", "}"],
                    ["[", "]"],
                    ["(", ")"],
                ],
                autoClosingPairs: [
                    { open: "{", close: "}" },
                    { open: "[", close: "]" },
                    { open: "(", close: ")" },
                    { open: '"', close: '"' },
                    { open: "'", close: "'" },
                    { open: "`", close: "`" },
                ],
                surroundingPairs: [
                    { open: "{", close: "}" },
                    { open: "[", close: "]" },
                    { open: "(", close: ")" },
                    { open: '"', close: '"' },
                    { open: "'", close: "'" },
                    { open: "`", close: "`" },
                ],
                folding: {
                    markers: {
                        start: /^\s*\/\/\s*#?region\b/,
                        end: /^\s*\/\/\s*#?endregion\b/,
                    },
                },
                onEnterRules: [
                    {
                        beforeText: /^\s*(?:\/\*|\/\/.*)?$/,
                        action: { indentAction: monaco.languages.IndentAction.None, appendText: "// " },
                    },
                ],
            });

            // Otomatik tamamlama sağlayıcısı ekle (her zaman güncel)
            this.cancels.forEach((disposeFn) => disposeFn());
            this.cancels = [];
            const disposable = monaco.languages.registerCompletionItemProvider(
                "javascript",
                createCompletionItemProvider(this.automationAttributes, this.moduleCache)
            );
            this.cancels.push(() => disposable.dispose());
        },
        destroyMonaco() {
            if (this.editor) {
                this.editor.dispose();
            }
        },
        handleResize() {
            if (this.editor) {
                this.editor.layout();
            }
        },
        showPromptWizard() {
            this.showJsAssistant = true;
            this.jsPrompt = "";
            // Modal açıldığında prompt alanına focus
            this.$nextTick(() => {
                if (this.$refs.promptTextarea) {
                    this.$refs.promptTextarea.focus();
                }
            });
        },
        handleAssistantClose() {
            this.showJsAssistant = false;
        },
        selectExamplePrompt(prompt) {
            this.jsPrompt = prompt;
        },
        openIDFinder() {
            this.addNewWindow({
                type: "id-finder",
                title: "ID Finder",
                description: "Sistem ID'lerini bulmak ve kopyalamak için kullanabilirsiniz",
                size: "large",
                autoClose: false,
                multiple: false,
                payload: {},
            });
        },
        wrapTryCatch(fn, defaultReturn = []) {
            try {
                return fn();
            } catch (error) {
                console.error(error);
                return defaultReturn;
            }
        },
        async generateJavaScriptCode() {
            if (!this.jsPrompt.trim()) {
                this.$message.warning("Lütfen bir istek yazın");
                return;
            }

            try {
                this.assistantLoading = true;

                // CoPilot servisini kullanarak AI'dan kod oluşturma
                const copilot = CoPilot.getInstance();

                // Mevcut otomasyon bilgilerini ve prompt'u AI'a gönderelim
                const response = await copilot.generateJavaScriptCode({
                    siteId: this.$store.state.site.site._id,
                    customerPrompt: this.jsPrompt,
                    automationAttributes: this.flatAutomationAttributes.map((x) => ({
                        label: x.fullLabel,
                        value: x.value,
                        valueType: x.valueType,
                    })),
                    blockId: this.blockId,
                    automationId: this.automation?._id || this.$store.state.automation.current?._id,
                    currentCode: this.payload.code,
                    user_list: this.users.map((x) => ({
                        name: x.name,
                        email: x.email,
                        id: x._id,
                        phone: x.phone,
                        isMe: x._id === this.me,
                    })),
                    id_list: [
                        // Etiketler
                        ...this.wrapTryCatch(
                            () =>
                                (this.$store.state.tag.tags.data || []).map((tag) => ({
                                    type: "tag",
                                    id: tag._id,
                                    name: tag.name,
                                    payload: { color: tag.color },
                                })),
                            []
                        ),
                        // Departmanlar
                        ...this.wrapTryCatch(
                            () =>
                                (this.$store.state.subject.subjects.data || [])
                                    .filter((dept) => !dept.isDeleted)
                                    .map((dept) => {
                                        const deptName =
                                            dept.name ||
                                            (dept.languageContent && typeof dept.languageContent === "object"
                                                ? dept.languageContent[Object.keys(dept.languageContent)[0]]?.name
                                                : Array.isArray(dept.languageContent) && dept.languageContent.length > 0
                                                ? dept.languageContent[0].name
                                                : "İsimsiz Departman");
                                        return {
                                            type: "department",
                                            id: dept._id,
                                            name: deptName,
                                            payload: { isActive: dept.isActive },
                                        };
                                    }),
                            []
                        ),
                        // İş Akışları (Workflows)
                        ...this.wrapTryCatch(
                            () =>
                                Object.values(this.$store.state.tasks.workflows || {}).map((wf) => ({
                                    type: "task_workflow",
                                    id: wf._id,
                                    name: wf.title,
                                    payload: { description: wf.description },
                                })),
                            []
                        ),
                        // Pipeline Aşamaları
                        ...this.wrapTryCatch(
                            () =>
                                Object.values(this.$store.state.tasks.workflows || {}).flatMap((wf) => {
                                    if (!wf.pipeline || !Array.isArray(wf.pipeline)) return [];
                                    return wf.pipeline.map((pipeline) => ({
                                        type: "task_workflow_pipeline_stage",
                                        id: pipeline._id,
                                        name: pipeline.name,
                                        payload: {
                                            workflowId: wf._id,
                                            workflowTitle: wf.title,
                                            color: pipeline.color,
                                            type: pipeline.type,
                                        },
                                    }));
                                }),
                            []
                        ),
                        // Kanallar
                        ...this.wrapTryCatch(
                            () =>
                                (this.$store.state.channel.channels || []).map((channel) => ({
                                    type: "channel",
                                    id: channel._id,
                                    name: channel.name,
                                    payload: { type: channel.type, enabled: channel.enabled },
                                })),
                            []
                        ),

                        // Otomasyonlar
                        ...this.wrapTryCatch(
                            () =>
                                (this.$store.state.automation.automations || [])
                                    .filter((auto) => !auto.isDeleted)
                                    .map((auto) => ({
                                        type: "automation",
                                        id: auto._id,
                                        name: auto.name,
                                        payload: {
                                            trigger: this.$_.get(auto.options, "trigger"),
                                            published: auto.published,
                                        },
                                    })),
                            []
                        ),
                        // Chatbotlar
                        ...this.wrapTryCatch(
                            () =>
                                (this.$store.state.CB.stories || []).map((story) => ({
                                    type: "chatbot",
                                    id: story._id,
                                    name: story.title,
                                    payload: {
                                        description: story.description,
                                        integrations: story.integrations,
                                    },
                                })),
                            []
                        ),
                    ],
                });

                if (response && response.code) {
                    console.log("response", response);
                    // Kodu editöre yerleştir
                    this.editor.setValue(response.code);
                    this.payload.code = response.code;
                    this.$emit("input", this.payload);

                    // Modal'ı kapat
                    this.showJsAssistant = false;
                    this.$message.success("JavaScript kodu başarıyla oluşturuldu");
                } else {
                    this.$message.error("Kod oluşturulurken bir hata oluştu");
                }
            } catch (error) {
                console.log(error);
                console.error("Kod üretme hatası:", error);
                this.$message.error("Kod oluşturulurken bir hata oluştu: " + (error.message || "Bilinmeyen hata"));
            } finally {
                this.assistantLoading = false;
            }
        },
        onEditorMounted(editor) {
            this.editor = editor;

            // Otomatik tamamlama için Register et
            this.registerEditor(editor, this.automationAttributes);

            // Supsis SDK şu an kullanılabilir
            editor.getModel().setValue(this.generatedCode || this.value);
        },
        toggleFullScreen() {
            this.isFullScreen = !this.isFullScreen;
            this.$nextTick(() => {
                if (this.editor) {
                    this.editor.layout();
                }
            });
        },
        checkUnsavedChanges() {
            return this.hasUnsavedChanges;
        },
        async handleModalClose() {
            if (this.hasUnsavedChanges) {
                try {
                    await this.$dialog.confirm(
                        'Kaydedilmemiş değişiklikleriniz var. Kaydetmeden çıkmak istediğinizden emin misiniz?',
                        {
                            title: 'Kaydedilmemiş Değişiklikler',
                            okText: 'Evet, Çık',
                            cancelText: 'İptal',
                            type: 'warning'
                        }
                    );
                    this.$emit('close');
                } catch (error) {
                    // Kullanıcı iptal etti, modal açık kalsın
                    return false;
                }
            } else {
                this.$emit('close');
            }
        },
        saveChanges() {
            this.originalCode = this.payload.code;
            this.hasUnsavedChanges = false;
        },
        handleKeyDown(event) {
            // ESC tuşu ile full screen'den çıkış
            if (event.key === 'Escape' && this.isFullScreen) {
                this.toggleFullScreen();
            }
        },
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
    watch: {
        moduleCache: {
            handler(newCache) {
                if (this.editor && newCache) {
                    console.log(
                        "Module cache changed, re-registering completion provider with cache:",
                        JSON.parse(JSON.stringify(newCache))
                    );
                    this.cancels.forEach((disposeFn) => disposeFn());
                    this.cancels = [];
                    const disposable = monaco.languages.registerCompletionItemProvider(
                        "javascript",
                        createCompletionItemProvider(this.automationAttributes, newCache)
                    );
                    this.cancels.push(() => disposable.dispose());
                }
            },
            deep: true,
        },
        "value.code": {
            handler(newValue) {
                // Dış değişiklikler olduğunda editörü güncelle (eğer editör ve model varsa)
                if (this.editor && this.editor.getModel() && newValue !== this.editor.getValue()) {
                    this.editor.setValue(newValue || "");
                }
            },
        },
        automation: {
            deep: true,
            handler() {
                this.loadAutomationAttributes();
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.automation-block-editor.run-javascript {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;
    overflow: visible; /* Container scroll'unu engellemek için */

    .editor-row {
        width: 100%;

        &.customize-editor-minimize {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
            margin-bottom: 10px;
        }
    }

    .code-editor-wrapper {
        background-color: #f7f7f7;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 20px;

        .code-editor-header {
            margin-bottom: 15px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .tips {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .tip {
                    // display: flex;
                    // align-items: center;
                    font-size: 14px;
                    color: #666;

                    md-icon {
                        margin-right: 8px;
                        font-size: 18px;
                    }
                }
            }

            .actions {
                .ai-assistant-btn,
                .id-finder-btn,
                .fullscreen-btn {
                    display: flex;
                    align-items: center;
                    background-color: #3a86ff;
                    color: white;
                    border: none;
                }

                .id-finder-btn {
                    background-color: #4caf50;
                }

                .fullscreen-btn {
                    background-color: #ff6b35;
                }
            }
        }

        .code-editor {
            margin-bottom: 20px;

            .available-libraries,
            .available-variables,
            .attribute-help {
                margin-bottom: 10px;
                font-size: 14px;

                code {
                    background-color: #e9e9e9;
                    padding: 2px 4px;
                    border-radius: 3px;
                    font-size: 12px;
                }
            }

            .attribute-help {
                background-color: #e3f1ff;
                border-radius: 5px;
                padding: 8px;
                margin-top: 10px;
                border-left: 3px solid #3a86ff;
            }

            .monaco-editor-container {
                width: 100%;
                height: 600px;
                border-radius: 5px;
                overflow: hidden;
                margin-top: 10px;
                position: relative;
                
                /* Monaco editor scroll'unu etkinleştir */
                .monaco-editor {
                    .overflow-guard {
                        overflow: auto !important;
                    }
                    
                    .monaco-scrollable-element {
                        overflow: auto !important;
                    }
                }

                &.fullscreen-editor {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    width: 100vw !important;
                    height: 100vh !important;
                    z-index: 9999 !important;
                    background-color: #1e1e1e !important;
                    border-radius: 0 !important;
                    margin: 0 !important;
                }
            }
        }

        .code-restrictions {
            margin-bottom: 20px;
            background-color: #fff0f0;
            padding: 10px 15px;
            border-radius: 5px;
            border-left: 3px solid #ff6b6b;

            .restriction-title {
                font-weight: bold;
                margin-bottom: 10px;
                color: #ff4757;
            }

            ul {
                margin: 0;
                padding-left: 20px;

                li {
                    font-size: 13px;
                    margin-bottom: 5px;
                    color: #555;
                }
            }
        }

        .example-usage {
            background-color: #f0f8ff;
            padding: 15px;
            border-radius: 5px;
            border-left: 3px solid #5352ed;

            .example-title {
                font-weight: bold;
                margin-bottom: 10px;
                color: #3742fa;
            }

            pre {
                background-color: #f8f9fa;
                padding: 15px;
                border-radius: 5px;
                overflow-x: auto;
                font-size: 13px;
                line-height: 1.5;
                color: #333;
                margin: 0;
            }
        }
    }
}

/* JavaScript Asistan Modal Stilleri */
.js-assistant-modal {
    display: flex;
    flex-direction: column;
    gap: 20px;

    .js-assistant-description {
        h4 {
            margin-bottom: 10px;
        }

        p {
            margin-bottom: 20px;
            color: #666;
        }

        .js-capabilities {
            background-color: #f8f9fa;
            border-radius: 8px;
            padding: 12px;
            margin-bottom: 20px;
            border: 1px dashed #d9d9d9;

            .capabilities-header {
                display: flex;
                align-items: center;
                margin-bottom: 10px;

                h5 {
                    margin: 0;
                    margin-left: 8px;
                    font-weight: 600;
                    font-size: 14px;
                }

                .anticon {
                    color: #1890ff;
                }
            }

            .capabilities-content {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 10px;

                .capability-item {
                    display: flex;
                    align-items: center;

                    .material-icons {
                        margin-right: 8px;
                        color: #1890ff;
                        font-size: 16px;
                    }

                    span {
                        font-size: 13px;
                    }
                }
            }
        }
    }

    .prompt-container {
        display: flex;
        flex-direction: column;
        gap: 15px;

        .example-prompts {
            display: flex;
            flex-wrap: wrap;
            gap: 10px;

            .example-prompt {
                flex: 1;
                min-width: 200px;
                background-color: #f0f7ff;
                border: 1px solid #d6e4ff;
                border-radius: 6px;
                padding: 10px;
                cursor: pointer;
                display: flex;
                align-items: center;

                &:hover {
                    background-color: #d6e4ff;
                }

                .anticon {
                    margin-right: 8px;
                    color: #1890ff;
                }

                span {
                    font-size: 13px;
                }
            }
        }

        .buttons-container {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            margin-top: 10px;
        }
    }
}
</style>
<style lang="scss">
.editor-widget {
    width: 100% !important;
}
</style>
